import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJobCommuteQueryVariables = Types.Exact<{
  jobKey: Types.Scalars['ID']['input'];
  commuteFrom: Types.CommuteLocationInput;
  commuteMethod?: Types.CommuteMethod;
}>;


export type GetJobCommuteQuery = { __typename?: 'Query', viewjob?: { __typename?: 'ViewJob', job?: { __typename?: 'Job', commute?: { __typename?: 'JobCommute', durationMinutes: number } | null } | null } | null };


export const GetJobCommuteDocument = gql`
    query GetJobCommute($jobKey: ID!, $commuteFrom: CommuteLocationInput!, $commuteMethod: CommuteMethod! = AUTOMOBILE_NO_TRAFFIC) {
  viewjob(input: $jobKey) {
    job {
      commute(from: $commuteFrom, method: $commuteMethod) {
        durationMinutes
      }
    }
  }
}
    `;

/**
 * __useGetJobCommuteQuery__
 *
 * To run a query within a React component, call `useGetJobCommuteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCommuteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCommuteQuery({
 *   variables: {
 *      jobKey: // value for 'jobKey'
 *      commuteFrom: // value for 'commuteFrom'
 *      commuteMethod: // value for 'commuteMethod'
 *   },
 * });
 */
export function useGetJobCommuteQuery(baseOptions: Apollo.QueryHookOptions<GetJobCommuteQuery, GetJobCommuteQueryVariables> & ({ variables: GetJobCommuteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobCommuteQuery, GetJobCommuteQueryVariables>(GetJobCommuteDocument, options);
      }
export function useGetJobCommuteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobCommuteQuery, GetJobCommuteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobCommuteQuery, GetJobCommuteQueryVariables>(GetJobCommuteDocument, options);
        }
export function useGetJobCommuteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobCommuteQuery, GetJobCommuteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobCommuteQuery, GetJobCommuteQueryVariables>(GetJobCommuteDocument, options);
        }
export type GetJobCommuteQueryHookResult = ReturnType<typeof useGetJobCommuteQuery>;
export type GetJobCommuteLazyQueryHookResult = ReturnType<typeof useGetJobCommuteLazyQuery>;
export type GetJobCommuteSuspenseQueryHookResult = ReturnType<typeof useGetJobCommuteSuspenseQuery>;
export type GetJobCommuteQueryResult = Apollo.QueryResult<GetJobCommuteQuery, GetJobCommuteQueryVariables>;